import { render, staticRenderFns } from "./ViewProductPublic.vue?vue&type=template&id=06901eea&scoped=true"
import script from "./ViewProductPublic.vue?vue&type=script&lang=js"
export * from "./ViewProductPublic.vue?vue&type=script&lang=js"
import style0 from "./ViewProductPublic.vue?vue&type=style&index=0&id=06901eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06901eea",
  null
  
)

export default component.exports